import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { themeNames } from '@upgrade/themes';
import Logo from '../Logo';
export default function FooterLogo({
  href = null,
  onClick = null,
  Link = 'a',
  linkProps = {}
}) {
  const theme = useTheme();
  const isUniversal = theme.name === themeNames.UNIVERSAL_CREDIT_THEME_NAME;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement(Link, _extends({}, linkProps, {
      href,
      onClick
    }), isUniversal ? /*#__PURE__*/React.createElement(Logo, {
      name: theme.name,
      direction: "vertical",
      color: "dark",
      className: "footer__logo",
      width: "9rem",
      height: "6.6rem"
    }) : /*#__PURE__*/React.createElement(Logo, {
      direction: "vertical",
      className: "footer__logo"
    }))
  );
}
FooterLogo.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  Link: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // eslint-disable-next-line react/forbid-prop-types
  linkProps: PropTypes.object
};
//# sourceMappingURL=logo.js.map